"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BUTTON_TYPES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Fab = _interopRequireDefault(require("@material-ui/core/Fab"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

var _reactRouterDom = require("react-router-dom");

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("../Typography"));

var _Button2 = _interopRequireDefault(require("./Button.css"));

var _utils = require("../../utils");

var BUTTON_TYPES = {
  primary: 'primary',
  secondary: 'secondary',
  tertiary: 'tertiary'
};
exports.BUTTON_TYPES = BUTTON_TYPES;

var PrimaryButton = function PrimaryButton(_ref) {
  var children = _ref.children,
      component = _ref.component,
      to = _ref.to,
      classes = _ref.classes,
      disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      iconed = _ref.iconed,
      isSimpleChildren = _ref.isSimpleChildren,
      textTransform = _ref.textTransform,
      onClick = _ref.onClick,
      rounded = _ref.rounded;
  return rounded ? React.createElement(_Fab.default, {
    children: children,
    component: component,
    to: to,
    disabled: disabled,
    className: (0, _clsx.default)(classes.root, iconed && classes.fabIcon, classes.textTransform, textTransform, classes.noShadow),
    classes: {
      label: classes.label
    },
    color: "primary",
    onClick: onClick,
    variant: isSimpleChildren ? 'extended' : 'round'
  }) : React.createElement(_Button.default, {
    children: children,
    component: component,
    to: to,
    disabled: disabled,
    fullWidth: fullWidth,
    className: (0, _clsx.default)(classes.root, classes.textTransform, textTransform, classes.noShadow),
    classes: {
      label: classes.label
    },
    color: "primary",
    onClick: onClick,
    variant: "contained"
  });
};

var SecondaryButton = function SecondaryButton(_ref2) {
  var children = _ref2.children,
      component = _ref2.component,
      to = _ref2.to,
      classes = _ref2.classes,
      disabled = _ref2.disabled,
      fullWidth = _ref2.fullWidth,
      iconed = _ref2.iconed,
      isSimpleChildren = _ref2.isSimpleChildren,
      textTransform = _ref2.textTransform,
      onClick = _ref2.onClick,
      rounded = _ref2.rounded;
  return rounded ? React.createElement(_Fab.default, {
    children: children,
    component: component,
    to: to,
    disabled: disabled,
    className: (0, _clsx.default)(classes.root, iconed && classes.fabIcon, classes.textTransform, textTransform, classes.noShadow, classes.fabOutlined, 'outline'),
    classes: {
      label: classes.label
    },
    color: "secondary",
    onClick: onClick,
    variant: isSimpleChildren ? 'extended' : 'round'
  }) : React.createElement(_Button.default, {
    children: children,
    component: component,
    to: to,
    disabled: disabled,
    fullWidth: fullWidth,
    className: (0, _clsx.default)(classes.root, classes.whiteBackground, classes.textTransform, textTransform),
    classes: {
      label: classes.label
    },
    color: "primary",
    onClick: onClick,
    variant: "outlined"
  });
};

var TertiaryButton = function TertiaryButton(_ref3) {
  var children = _ref3.children,
      component = _ref3.component,
      to = _ref3.to,
      classes = _ref3.classes,
      disabled = _ref3.disabled,
      fullWidth = _ref3.fullWidth,
      iconed = _ref3.iconed,
      isSimpleChildren = _ref3.isSimpleChildren,
      textTransform = _ref3.textTransform,
      onClick = _ref3.onClick,
      rounded = _ref3.rounded;
  return rounded ? React.createElement(_Fab.default, {
    children: children,
    component: component,
    to: to,
    disabled: disabled,
    className: (0, _clsx.default)(classes.root, iconed && classes.fabIcon, classes.textTransform, textTransform, classes.noShadow, classes.fabOutlined),
    classes: {
      label: classes.label
    },
    color: "secondary",
    onClick: onClick,
    variant: isSimpleChildren ? 'extended' : 'round'
  }) : React.createElement(_Button.default, {
    children: children,
    component: component,
    to: to,
    disabled: disabled,
    fullWidth: fullWidth,
    className: (0, _clsx.default)(classes.root, classes.whiteBackground, classes.textTransform, textTransform),
    classes: {
      label: classes.label
    },
    color: "primary",
    onClick: onClick
  });
};

var buttonTypes = {
  primary: PrimaryButton,
  secondary: SecondaryButton,
  tertiary: TertiaryButton
};

var Button =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(Button, _React$PureComponent);

  function Button() {
    (0, _classCallCheck2.default)(this, Button);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Button).apply(this, arguments));
  }

  (0, _createClass2.default)(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          disabled = _this$props.disabled,
          font = _this$props.font,
          fullWidth = _this$props.fullWidth,
          href = _this$props.href,
          onClick = _this$props.onClick,
          textTransform = _this$props.textTransform,
          type = _this$props.type,
          rounded = _this$props.rounded;
      var linkProps = {};

      if (href) {
        linkProps.component = _reactRouterDom.Link; // while `to` is not a Button/Fab prop, it is a Link prop

        linkProps.to = href;
      }

      var ButtonComponent = buttonTypes[type] || PrimaryButton;
      var iconComponent = this.iconComponent;
      return React.createElement(ButtonComponent, (0, _extends2.default)({}, linkProps, {
        classes: classes,
        disabled: disabled,
        fullWidth: fullWidth,
        isSimpleChildren: (0, _utils.isTextContent)(children),
        onClick: onClick,
        textTransform: textTransform,
        rounded: rounded,
        iconed: iconComponent
      }), iconComponent ? iconComponent : (0, _utils.isTextContent)(children) ? React.createElement(_Typography.default, {
        className: (0, _clsx.default)(classes.label, classes.textTransform, textTransform),
        variant: font
      }, children) : children);
    }
  }, {
    key: "iconComponent",
    get: function get() {
      switch (this.props.icon) {
        case 'add':
          return React.createElement(_Add.default, null);

        default:
          return null;
      }
    }
  }]);
  return Button;
}(React.PureComponent);

Button.defaultProps = {
  children: null,
  classes: {},
  disabled: false,
  font: 'button',
  fullWidth: false,
  href: undefined,
  onClick: function onClick() {},
  size: '2x',
  textTransform: 'inherit',
  type: BUTTON_TYPES.primary,
  rounded: false
};
Button.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  disabled: PropTypes.bool,
  font: PropTypes.oneOf(['button', 'button2']),
  fullWidth: PropTypes.bool,
  href: PropTypes.string,
  icon: PropTypes.string,
  onClick: PropTypes.func,

  /**
   * The width and height of the rounded button
   */
  size: PropTypes.oneOf(['1x', '2x', '3x', 24, 40, 64]),
  textTransform: PropTypes.oneOf(['uppercase', 'capitalize', 'lowercase', 'inherit']),
  type: PropTypes.oneOf(Object.keys(BUTTON_TYPES)),
  rounded: PropTypes.bool
};

var _default = (0, _styles.withStyles)(_Button2.default)(Button);

exports.default = _default;